/**
 * @generated SignedSource<<e6c495096c966063b086730be423b891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateLlmConversationInput = {
  conversationId: any;
  title: string;
};
export type useLlmConversationActionsRenameConversationMutation$variables = {
  input: UpdateLlmConversationInput;
};
export type useLlmConversationActionsRenameConversationMutation$data = {
  readonly updateLlmConversation: {
    readonly conversation: {
      readonly id: any;
      readonly title: string;
    } | null | undefined;
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type useLlmConversationActionsRenameConversationMutation = {
  response: useLlmConversationActionsRenameConversationMutation$data;
  variables: useLlmConversationActionsRenameConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateLlmConversationPayload",
    "kind": "LinkedField",
    "name": "updateLlmConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLlmConversationActionsRenameConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLlmConversationActionsRenameConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26a9477744cfc0cd08d93c89db0947cc",
    "id": null,
    "metadata": {},
    "name": "useLlmConversationActionsRenameConversationMutation",
    "operationKind": "mutation",
    "text": "mutation useLlmConversationActionsRenameConversationMutation(\n  $input: UpdateLlmConversationInput!\n) {\n  updateLlmConversation(input: $input) {\n    success\n    error\n    conversation {\n      id\n      title\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2beb542c55f3152cfb0713234882d2d9";

export default node;
